export enum Permissions {
  Account_management = '1',
  Customer_management = '2',
  Add_customer = '2-1',
  Edit_customer = '2-2',
  Open_renewal_package = '2-3',
  Assign_staff = '2-4',
  Delete_customer = '2-5',
  Customer_protection = '3',
  Account_authorization_management = '4',
  Financial_statement = '6',
  Case_query = '7',
  Service = '8',
  Service_message = '8-1',
  Service_comment = '8-2',

}

export type Permission = (typeof Permissions)[keyof typeof Permissions];

export enum Role {
  Admin = "Admin",
  Service = "Service",
  Market = "Market",
  ServiceLead = "ServiceLead",
}
